import React from "react";
import Header3 from '../header3/Header3';

export default function Navbar3(props) {
  const [scroll, setScroll] = React.useState(0);

  const handleScroll = () => setScroll(document.documentElement.scrollTop);

  React.useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // const className = scroll > 80 ? "fixed-navbar" : "fixed-navbar";

  return (
    <div>
        <Header3 hclass={props.hclass} Logo={props.Logo} topbarNone={props.topbarNone}/>
    </div>
  ); 
}